import React, { Component } from 'react';

class StateStore extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.state;
    this.handler = this.handler.bind(this);
  }
  handler(args) {
    this.setState(args);
  }
  render() {
    return this.props.children(this.state, this.handler);
  }
}

export const hasStateStore = (WrappedComponent) => {
  return (props) => {
    return <StateStore>
      {(state, handler) => <WrappedComponent
        {...state} onChange={handler} {...props}/>}
    </StateStore>
  }
};

export default StateStore;



// WEBPACK FOOTER //
// ./src/Common/StateStore.js